import React from 'react';
import { useChatbot } from '../../context/ChatbotContext';
import { OverviewTab } from '../../components/chatbot/tabs/OverviewTab';

const ChatbotOverviewPage: React.FC = () => {
  const { account } = useChatbot();
  return <OverviewTab account={account} />;
};

export default ChatbotOverviewPage;
